import React from 'react';
import Carousel from '@brainhubeu/react-carousel';

import Image from './Image';
import photos from '../data/galleryPhotos';

import './Galeria.css';
import '@brainhubeu/react-carousel/lib/style.css';

const Galeria = () => {
  const Images = photos.map((img, index) => {
    const { imgSrc, altText } = img;
    const key = index;
    return (
      <Image
        key={key}
        className='gallery-image'
        imgSrc={imgSrc}
        altText={altText}
      />
    );
  });
  return (
    <div>
      <Carousel arrows centered infinite>
        {Images}
      </Carousel>
    </div>
  );
};
export default Galeria;
